import React, { FC } from 'react'

export const Home: FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.335 16.667v-5h3.333v5h4.167V10h2.5L10 2.5 1.668 10h2.5v6.667h4.167Z"
      fill="#000"
    />
  </svg>
)
